<div class="dialog-wrapper">
  <div class="dialog-header">
    <h3>Notes by {{ userName }}</h3>
    <ng-icon name="heroXMark" (click)="onClose()" class="cursor-pointer"></ng-icon>
  </div>
  <mat-dialog-content>
    <!-- Loading state -->
    <div *ngIf="notesLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading notes...</p>
    </div>

    <!-- Notes list -->
    <div *ngIf="!notesLoading && notes.length > 0" class="notes-list">
      <div class="note-item" *ngFor="let note of notes">
        <div class="note-header">
          <div class="note-title">
            <strong>{{ note.note }}</strong>
          </div>
          <div class="note-date">
            {{ formatDateTime(note.updateDate) }}
          </div>
        </div>
        <div class="note-comments" *ngIf="note.comments">
          {{ note.comments }}
        </div>
      </div>
    </div>

    <!-- No notes state -->
    <div *ngIf="!notesLoading && notes.length === 0" class="no-notes">
      <mat-icon>note</mat-icon>
      <h4>No Notes Found</h4>
      <p>This user has not added any notes for this contract.</p>
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="onClose()" class="outlined-btn">
      Close
    </button>
  </mat-dialog-actions>
</div>

